import * as Blob_bs$SolvuuApi0 from "./blob_bs.bs.js";
import * as Void_bs$SolvuuApi0 from "./void_bs.bs.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
var write_bad_request = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr0("Invalid_source_uri");
});
var read_bad_request = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Invalid_source_uri",
/* `Single */
[-306849112,
/* Invalid_source_uri */
31475312]],
/* [] */
0]);
var read_ok = Blob_bs$SolvuuApi0.read_t;
var write_ok = Blob_bs$SolvuuApi0.write_t;
var read_not_found = Void_bs$SolvuuApi0.read_t;
var write_not_found = Void_bs$SolvuuApi0.write_t;
export { read_ok, write_ok, read_not_found, write_not_found, read_bad_request, write_bad_request };
/* write_bad_request Not a pure module */